<template>
  <div
    v-if="checkIsIfMiniapp() && paymentOffers?.length > 0"
    class="payment-offer-wrap mb32 carousel-pr-12"
  >
    <div
      v-if="modulePropsData?.title"
      class="mb12 flex-row pl12"
      :vwoObserver="vwoExperiments"
    >
      <div class="lh21 fs-18 bold">{{ modulePropsData.title }}</div>
      <span v-if="modulePropsData?.subTitle" class="lh16 fs-14 bold">{{
        modulePropsData?.subTitle
      }}</span>
    </div>

    <Carousel
      :pauseAutoplayOnHover="true"
      :transition="500"
      :itemsToShow="itemsToShow"
    >
      <Slide v-for="(item, index) in paymentOffers" :key="item?.id">
        <div
          @touchstart.stop
          @touchmove.stop
          class="payment-offer-item pr flex-column pl12 pb12"
        >
          <Observer
            :options="{ rootMargin: '0px' }"
            @intersect="offersVisible(index)"
          />
          <div class="corner-image" v-if="item?.logo">
            <lazy-image
              :src="item?.logo"
              class="banners-item flex-row fs-20"
              alt="payment option image"
            />
          </div>
          <div class="flex-column upper pt16 pr12">
            <p class="title fs-18 lh25 bold">{{ item?.title }}</p>
            <p class="description fs-12 lh18">
              {{ item?.subTitle }}
            </p>
          </div>
          <div class="flex-row lower pr12 pt5">
            <p
              @click="triggerTncModal(item, index)"
              class="more-details fs-12 lh14 bold"
            >
              More details
            </p>
            <button
              class="line-btn sm"
              @click="triggerPaymentOfferAppliedModal(index)"
              v-if="appliedOfferDetails?.paymentId != item.paymentId"
            >
              Select
            </button>
            <div
              v-if="appliedOfferDetails?.paymentId == item.paymentId"
              class="flex-row already-applied fs-12 lh18"
              @click="triggerTncModal(item, index)"
            >
              <div class="faded-border"></div>
              <i class="jfi-checkmark-circled fs-13"></i>
              <div>Selected!</div>
            </div>
          </div>
        </div>
      </Slide>
      <template #addons> </template>
    </Carousel>

    <!-- offer details popup -->
      <payment-offer-details-modal 
        v-if="tncModalFlag"
        :data-modal-dimensions="tncModalDim"
        :generic-modal-source="'paymentOfferDetail'"
        :data-tnc-modal-flag="tncModalFlag"
        :data-offer-details="paymentOffers[selectedOfferIndex]"
        :data-should-show-remove-offer="shouldShowRemoveOffer"
        :data-tnc="selectedPaymentOfferTnc?.tnc"
        @closeModal="closeTncModal('dismiss')"
        @close="closeTncModal('cross')"
        @removePaymentOffer="removePaymentOffer"
        @triggerPaymentOfferAppliedModal="triggerPaymentOfferAppliedModal(selectedOfferIndex)"
      />

    <generic-modal
      v-if="showOfferAppliedModal"
      @close="closeAppliedModal()"
      :height="'auto'"
      :width="msModalDim.width"
      :modalClass="msModalDim.modalClass"
    >
      <template v-slot:header>
        <p></p>
      </template>
      <template v-slot:body>
        <div class="lottie-confetti">
          <VueLottiePlayer
            :path="
              staticImgBaseUrl +
              '/images/animation/confetti.json'
            "
            name="confettiAnim"
            width="100%"
            height="100%"
            loop
          />
        </div>
        <div class="lottie-offer-icon">
          <VueLottiePlayer
            :path="
              staticImgBaseUrl +
              '/images/animation/offer-icon-animation.json'
            "
            name="offerIconAnim"
            width="100%"
            height="100%"
            loop
          />
        </div>
        <div class="offer-applied-popup tc flex-column">
          <div class="fs-18 lh18 normal mb10">
            <!-- Coupon Code -->
            <span class="upercase bold">{{
              paymentOffers[selectedOfferIndex].paymentModeName
            }}</span>
            <span class="bold"> payment mode selected!</span>
          </div>
          <div class="mt5 lh18 fs-12">you can change later in the cart</div>
        </div>
      </template>
      <template v-slot:footer>
        <div></div>
      </template>
    </generic-modal>
    <!-- <offer-shown-modal></offer-shown-modal> -->
  </div>
</template>

<script>
import { Carousel, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import Utility from "../helpers/utility";
import GenericModal from "./GenericModal.vue";
import LocalStorageFunc from "../helpers/localStorageFunc";
import setEvents from "../helpers/events";
import Observer from "../assets/Observer.vue";
import userActivityTracking from "../helpers/UserActivityTracking";
import LazyImage from "./LazyImage.vue";
import { staticImgBaseUrl } from "../config/apiEndpoints";
import {
  keyMapsAction,
  keyMapsMutation,
  keyMapsGetter,
} from "../helpers/storeKeys";
import OfferShownModal from "./OfferShownModal.vue";
import { VWO_NEXTGEN_HOMEPAGE_EXPERIMENT } from "../config/vwoKeys";
import { defineAsyncComponent } from "vue";

export default {
  name: "PaymentOfferItem",
  props: ["dataResults", "moduleProps"],
  components: {
    Carousel,
    Slide,
    GenericModal,
    VueLottiePlayer: defineAsyncComponent(() => import("vue-lottie-player")),
    OfferShownModal,
    Observer,
    PaymentOfferDetailsModal: defineAsyncComponent(() => import("./PaymentOfferDetailsModal.vue")),
    LazyImage,
  },
  data() {
    return {
      data: [],
      modulePropsData: {},
      itemsToShow: 1,
      currentSlide: 0,
      tncModalDim: {
        width: "100vw",
        height: "calc(91vh - 56px)",
        animationStyle: "slide-up-stick-bottom",
        modalClass: "tnc-modal",
      },
      msModalDim: {
        width: "100vw",
        height: "calc(91vh - 56px)",
        animationStyle: "slide-up-stick-bottom",
        modalClass: "modal-bg-blackout hide-vertical-scrollbar",
      },
      showOfferAppliedModal: false,
      isImpressionProcessed: {},
      autoApplyFlag: false,
      staticImgBaseUrl: staticImgBaseUrl,
    };
  },
  mounted() {
    this.data = Utility.tryJsonParse(this.dataResults, []);
    this.modulePropsData = Utility.tryJsonParse(this.moduleProps);
    this.itemsToShow = +this.modulePropsData?.itemsInScreen;
    this.$store.commit(keyMapsMutation.UPDATE_PAYMENT_OFFER_ITEMS, this.data);
    this.$store.commit(
      keyMapsMutation.UPDATE_PAYMENT_OFFER_DETAILS,
      LocalStorageFunc.getPaymentOfferMode() || {}
    );
  },
  methods: {
    checkIsIfMiniapp() {
      return !Utility.checkIfIsMiniApp();
    },
    offersVisible(index) {
      if (!this.isImpressionProcessed[index + 1]) {
        this.isImpressionProcessed[index + 1] = true;
        this.eventFunction(false, {}, index);
      }
    },
    autoApply() {
      let _ = Utility.tryJsonParse(_siteProps_.props.autoApplyOffer);
      if (_?.type == "PAYMENT" && _?.code) {
        for (let i = 0; i < this.paymentOffers.length; i++) {
          if (this.paymentOffers[i].paymentId == _.code) {
            LocalStorageFunc.setSessionStorageKey("isAutoApplyInitiated", true);
            this.triggerPaymentOfferAppliedModal(i);
            break;
          }
        }
      }
    },
    eventFunction(isClicked = false, eObj = {}, index) {
      let eventType = isClicked ? "Click" : "Impression";
      let userAction = isClicked ? "click" : "impression";
      let preEventObj = { ...eObj };
      preEventObj["positionWithinSection"] = index + 1;
      preEventObj["category"] = this.paymentOffers[index]?.title?.toLowerCase();
      preEventObj["offerType"] = "payment offer";
      preEventObj["offerStage"] =
        this.appliedOfferDetails?.paymentId ===
        this.paymentOffers[index]?.paymentId
          ? "applied"
          : "not applied";
      const eventObj = Utility.amplitudeEventObj(
        userAction,
        "payment offers",
        "9",
        preEventObj
      );
      setEvents("amplitude", eventType, eventObj);
    },
    triggerTncModal(item, index) {
      userActivityTracking.paymentOfferView(item, 0);
      this.$store.commit(
        keyMapsMutation.UPDATE_SELECTED_PAYMENT_OFFER_INDEX,
        index
      );
      this.$store.dispatch(keyMapsAction.PAYMENT_OFFER_TNC_API, {
        offerId: this.paymentOffers[index].id,
        langId: 1,
        platform: window?._siteProps_?.platform
          ? (window?._siteProps_?.platform).toLowerCase()
          : "pwa",
      });
      document.body.classList.add("body-stop-scroll-mobile");
      this.$store.commit(keyMapsMutation.UPDATE_TNC_MODAL_FLAG, true);
      this.eventFunction(
        true,
        {
          subCategory: "more details",
        },
        index
      );
      this.eventFunction(
        false,
        {
          subCategory: "more details",
        },
        index
      );
    },
    closeTncModal(source) {
      document.body.classList.remove("body-stop-scroll-mobile");
      this.$store.commit(keyMapsMutation.UPDATE_TNC_MODAL_FLAG, false);
      if (source) {
        this.eventFunction(
          true,
          {
            subCategory: "more details",
            actionType: source == "cross" ? "cross tap" : "default dismiss",
          },
          this.selectedOfferIndex
        );
      }
    },
    triggerPaymentOfferAppliedModal(index) {
      this.$store.commit(
        keyMapsMutation.UPDATE_SELECTED_PAYMENT_OFFER_INDEX,
        index
      );
      this.closeTncModal();
      let addZindex = document.getElementById("offerApply");
      addZindex && addZindex.classList.remove("z-index-offer-applied");
      let appliedOffer = {
        status: "",
        label: this.paymentOffers[this.selectedOfferIndex].title,
        name: this.paymentOffers[this.selectedOfferIndex].paymentId,
        index: 1,
        paymentId: this.paymentOffers[this.selectedOfferIndex].paymentId,
        paymentMode: this.paymentOffers[this.selectedOfferIndex].paymentId,
      };
      this.$store.commit(
        keyMapsMutation.UPDATE_PAYMENT_OFFER_DETAILS,
        appliedOffer
      );

      document.body.classList.add("body-stop-scroll-mobile");
      this.showOfferAppliedModal = true;
      userActivityTracking.paymentOfferSelected(
        0,
        this.paymentOffers[index].paymentId
      );
      setTimeout(this.closeAppliedModal, 3000);
      this.eventFunction(
        true,
        {
          subCategory: "select",
          actionType: "select",
        },
        index
      );
    },
    removePaymentOffer() {
      this.$store.commit(keyMapsMutation.UPDATE_PAYMENT_OFFER_DETAILS, {});
      LocalStorageFunc.updatePaymentOfferpaymentId({});
      this.closeTncModal();
      this.eventFunction(
        true,
        {
          subCategory: "more details",
          offerStage: "applied",
          actionType: "remove",
        },
        this.selectedOfferIndex
      );
    },
    closeAppliedModal(event) {
      document.body.classList.remove("body-stop-scroll-mobile");
      this.showOfferAppliedModal = false;
    },
  },
  computed: {
    paymentOffers() {
      return this.$store.state.PaymentOffers.paymentOffers;
    },
    selectedOfferIndex() {
      return this.$store.state.PaymentOffers.selectedOfferIndex;
    },
    shouldShowRemoveOffer() {
      let sO = this.$store.state.PaymentOffers.selectedOfferIndex;
      let aO = this.$store.state.PaymentOffers.appliedOfferDetails;
      if (!aO?.paymentId) {
        return false;
      } else {
        return this.paymentOffers[sO]?.paymentId == aO?.paymentId;
      }
    },
    appliedOfferDetails() {
      return this.$store.state.PaymentOffers.appliedOfferDetails;
    },
    tncModalFlag() {
      return this.$store.state.PaymentOffers.tncModalFlag;
    },
    selectedPaymentOfferTnc() {
      return this.$store.state.PaymentOffers.selectedPaymentOfferTnc;
    },
    isLocationSettled() {
      return this.$store.state.Location.isLocationSettled;
    },
    vwoExperiments() {
      let _ = this.$store.state.Config.vwoExperiments;
      let autoApplyDefaultPersonalisedOfferRef =
        this.$store.state.Offers.autoApplyDefaultPersonalisedOfferRef;
      if (_?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] === "nextgen_variant_d") {
        if (
          autoApplyDefaultPersonalisedOfferRef &&
          !(LocalStorageFunc.getPaymentOfferMode() || {}).paymentId &&
          !this.autoApplyFlag &&
          this.isLocationSettled &&
          LocalStorageFunc.getSessionStorageKey("isAutoApplyInitiated") != true
        ) {
          this.autoApplyFlag = true;
          setTimeout(() => {
            this.autoApply();
          }, 2000);
        }
      }
    },
  },
};
</script>
